module.exports = __webpack_public_path__ + "static/media/workplace.e0577fad.jpeg";